import { settings } from '../core/storage.js';
import { t } from '../core/i18n.js';
import { SKINS } from '../core/skins.js';
import { escapeHtml } from '../core/utils.js';

/* Selector de skin (color de acento). Al elegir uno se aplica al instante, para verlo cambiar
   con la lista abierta; se cierra con la X o con Atrás. */

let seq = 0;

function row(skin, active) {
    return `<button type="button" class="setting skin-row ${active ? 'is-active' : ''}" data-skin-id="${skin.id}">
        <span class="skin-dot" style="background:${skin.accent}"></span>
        <span class="setting-body"><span class="setting-title">${escapeHtml(t('skin.' + skin.id))}</span></span>
        ${active ? '<span class="mi skin-check">check</span>' : ''}
    </button>`;
}

export function openSkinPicker(onChange) {
    const app = window.app;
    const id = 'skin-' + (++seq) + '-' + Date.now().toString(36);
    const html = `<div class="popup catpick-popup admin-popup is-compact" id="${id}">
        <div class="view"><div class="page">
            <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                <div class="title">${t('settings.skin')}</div>
                <div class="right"><a href="#" class="link popup-close" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
            </div></div>
            <div class="page-content">
                <p class="px small muted">${t('settings.skinSub')}</p>
                <div class="admin-list skin-list" data-list></div>
            </div>
        </div></div>
    </div>`;

    const popup = app.popup.create({
        content: html,
        on: {
            open(p) {
                const list = p.el.querySelector('[data-list]');
                const paint = () => {
                    const current = settings.get('skin') || 'default';
                    list.innerHTML = SKINS.map((s) => row(s, s.id === current)).join('');
                };
                paint();
                list.addEventListener('click', (e) => {
                    const btn = e.target.closest('[data-skin-id]');
                    if (!btn) return;
                    e.preventDefault();
                    const skinId = btn.getAttribute('data-skin-id');
                    if ((settings.get('skin') || 'default') === skinId) return;
                    settings.set('skin', skinId);
                    if (onChange) onChange();
                    paint();
                    const again = list.querySelector(`[data-skin-id="${skinId}"]`);
                    if (again && window.IPTV.device.isTV) window.IPTV.tvnav.focus(again);
                });
            },
            closed(p) {
                p.destroy();
                const el = document.getElementById(id);
                if (el) el.remove();
            }
        }
    });
    popup.open();
}
